import { msg } from '@tov-plus/ui';
const styleKeys: Readonly<Record<string, string>> = {
  romantic: 'guest.theme.style.romantic',
  editorial: 'guest.theme.style.editorial',
  formal: 'guest.theme.style.formal',
  classic: 'guest.theme.style.classic',
  modern: 'guest.theme.style.modern',
  minimal: 'guest.theme.style.minimal',
  playful: 'guest.theme.style.playful',
};
export function formatGuestThemeStyle(value: string) {
  return Object.hasOwn(styleKeys, value) ? msg(styleKeys[value]!) : value;
}
